export const queryStringToObject = <T = Record<string, string>>(url: string): T =>
  [...new URLSearchParams(url.split('?')[1])].reduce<T>((a, [k, v]) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    a[k] = v;

    return a;
  }, {} as T);
